var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMof(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.176 4.264a2.008 2.008 0 1 1-4.017 0 2.008 2.008 0 0 1 4.016 0zM13.24 7.526l-.073.001a3.264 3.264 0 1 1 1.3-.27l.764 3.918a4.456 4.456 0 0 1 4.101 6.707l4.924 4.87a2.887 2.887 0 1 1-.774 1l-4.937-4.884a4.44 4.44 0 0 1-3.055 1.212c-.439 0-.862-.064-1.263-.182l-2.614 6.753a2.51 2.51 0 1 1-4.06.952l-1.356-1.028a2.134 2.134 0 1 1 .736-.702l1.16.88c.21-.22.46-.402.739-.533l.002-.003.177-.144.134.023a2.51 2.51 0 0 1 1.597.026l2.562-6.615A4.458 4.458 0 0 1 14 11.423l-.76-3.897zm-3.396 19.71a1.255 1.255 0 1 0 .538.092l-.538-.092zm16.252-.63a1.632 1.632 0 1 0 0-3.263 1.632 1.632 0 0 0 0 3.264zm-20.962-.752a1.13 1.13 0 1 0 0-2.26 1.13 1.13 0 0 0 0 2.26zm12.803-10.23a2.448 2.448 0 1 1-4.895 0 2.448 2.448 0 0 1 4.895 0z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMof);
export default __webpack_public_path__ + "static/media/MOF.41726b8d692d2ccebc18d75ac257d3d5.svg";
export { ForwardRef as ReactComponent };